module.exports = __webpack_public_path__ + "assets/logo_sq_colored-9c9db8.svg";